export default {
  functionKey: "SI",
  title: "SI",
  group: "Organisation",
  target: [],
  targetRequired: true,
  arguments: [],
  maxArguments: 3,
  requiredArguments: [
    { argumentKey: "Condition", name: "Condition (colonne)" },
    { argumentKey: "IfTrue",    name: "Si vrai", empty: true },
    { argumentKey: "IfFalse",   name: "Si faux", empty: true }
  ],
  expectedArguments: [
    { name: "Condition (colonne)", argumentKey: "Condition", single: true, initialValue: "" },
    { name: "Si vrai",             argumentKey: "IfTrue",    single: true, initialValue: "" },
    { name: "Si faux",             argumentKey: "IfFalse",   single: true, initialValue: "" }
  ],
  description: "Retourne une valeur selon une condition. (Ex: SI(colonne, 'oui', 'non'))",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    if (args.length < 3) return { displayCode: "", safeCode: "" };
    const code = `${destination} = (${args[0]}) ? ${args[1]} : ${args[2]};`;
    return { displayCode: code, safeCode: code };
  }
}
